export default __webpack_public_path__ + "static/media/exclamation.e604e14b.svg";